module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang === 'ru' || _vm.lang === 'en') ? _c('div', {
    staticClass: "lang-block",
    class: {
      'fixed': _vm.fixed
    }
  }, [(_vm.lang === 'ru') ? [_c('span', [_vm._v("RU")]), _vm._v("   |   "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function (e) { return _vm.onLangClickDebounce('en', e); }
    }
  }, [_vm._v("EN")])] : _vm._e(), _vm._v(" "), (_vm.lang === 'en') ? [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function (e) { return _vm.onLangClickDebounce('ru', e); }
    }
  }, [_vm._v("RU")]), _vm._v("   |   "), _c('span', [_vm._v("EN")])] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3a3ced"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/lang.vue
// module id = 765
// module chunks = 0